
import { defineComponent, ref, onMounted } from 'vue'
import { useRoute } from 'vue-router';
import RepmanService from '@/core/services/RepmanService';
import { errManager } from "@/core/config/Tools";

export default defineComponent({
    name: "manager-clubs-repman",
    setup() {
        const route = useRoute();
        const { id } = route.params
        const loader = ref(false)
        const search = ref("")
        const listRepam = ref<any>([])

        const getListRepman = async () => {
            loader.value = true
            await RepmanService.getData({idclub: id})
            .then((res)=>{
                listRepam.value = res.data
                loader.value = false
            }).catch(({ response })=>{
                loader.value = false
                errManager(response)
            })
        }

        onMounted(()=>{
            getListRepman()
        })

        return {
            id,
            loader,
            search,
            listRepam
        }

    },
})
